import { render, staticRenderFns } from "./Secretarias.vue?vue&type=template&id=fb31a224&"
import script from "./Secretarias.vue?vue&type=script&lang=js&"
export * from "./Secretarias.vue?vue&type=script&lang=js&"
import style0 from "./Secretarias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports